import { CSSProperties } from 'react';

import { SVGIconProps } from '../types';


type Props = Omit<SVGIconProps, 'style'> & {
  style?: CSSProperties;
  size?: string | number;
};

export const CoverageEndedIconNoBackground = ({
  style,
  color = 'currentColor',
  size = 16,
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="-1.2 -1.2 12.6 12.6"
      fill="none"
      style={style}
    >
      <path
        d="M1.87259 1.84996C1.43978 2.27629 1.09566 2.78409 0.860085 3.34407C0.624509 3.90404 0.502137 4.50512 0.500028 5.11263C0.497918 5.72014 0.616114 6.32205 0.847796 6.88365C1.07948 7.44525 1.42006 7.95542 1.8499 8.38474C2.27974 8.81407 2.79034 9.15404 3.35223 9.38505C3.91412 9.61606 4.51619 9.73354 5.12371 9.73072C5.73123 9.72789 6.33218 9.60482 6.8919 9.36859C7.45162 9.13236 7.95903 8.78766 8.38486 8.35436M9.24088 7.16802C9.67506 6.30359 9.82581 5.32434 9.67171 4.36936C9.51762 3.41439 9.06652 2.53224 8.3825 1.84824C7.69847 1.16423 6.8163 0.713145 5.86129 0.559057C4.90628 0.404968 3.927 0.55571 3.06254 0.989872M0.526155 0.5L9.73077 9.70433"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
